import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../../Components/Functions/date.fun";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { BsJournalArrowUp } from "react-icons/bs";
import { useSelector } from "react-redux";
import CustomSelect from "../../../CustomComponent/custom_select";

const FarmerInventoryTable = ({
  data,
  currentPage,
  itemsPerPage,
  refresh,
  setRefresh,
}) => {
  const navigate = useNavigate();

  const [variantRows, setVariantRows] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [instock, setInStock] = useState();
  const store = useSelector((store) => store.login.user);

  /* ---------- GROUP PRODUCTS ---------- */

  const groupedProducts = Object.values(
    (data || []).reduce((acc, item) => {
      if (!acc[item.productId]) {
        acc[item.productId] = {
          ...item,
          variants: [],
        };
      }

      acc[item.productId].variants.push(item);

      return acc;
    }, {})
  );

  /* ---------- VIEW PAGE ---------- */

  const goToView = (id) => {
    console.log("Id is", id);
    navigate(`/epg-farmer-inventory/view/${id}`);
  };

  /* ---------- OPEN Update MODAL ---------- */

  const openUpdateModal = (item) => {
    console.log("item is", item);
    const variantsWithQty = item.variants.map((v) => ({
      ...v,
      quantity: v.quantity || 0,
    }));

    setSelectedProduct(item);
    setVariantRows(variantsWithQty);
  };

  const openAddStockModal = (item) => {
    const variantsWithQty = item.variants.map((v) => ({
      variantId: v.variantId || v.id,
      productId: v.productId || item.productId,
      pmg_product_variant: v.pmg_product_variant,
      quantity: "",
    }));

    setSelectedProduct(item);
    setInStock(variantsWithQty);
  };

  /* ---------- In Stock Details Model ---------- */

  const openInstockUpdateModal = (item) => {
    const variantsWithQty = item.variants.map((v) => ({
      variantId: v.variantId || v.id,
      productId: v.productId,
      pmg_product_variant: v.pmg_product_variant,
      quantity: v.quantity,
    }));

    setSelectedProduct(item);
    setVariantRows(variantsWithQty);
  };

  /* ---------- QUANTITY CHANGE ---------- */

  const handleVariantQtyChange = (index, value) => {
    const numericValue = value.replace(/\D/g, "");

    // UPDATE UPDATE-STOCK MODAL
    setVariantRows((prevRows) => {
      const updatedRows = [...prevRows];

      updatedRows[index] = {
        ...updatedRows[index],
        quantity: numericValue === "" ? "" : Number(numericValue),
      };

      return updatedRows;
    });

    // UPDATE ADD-STOCK MODAL
    setInStock((prevRows = []) => {
      const updatedRows = [...prevRows];

      if (updatedRows[index]) {
        updatedRows[index] = {
          ...updatedRows[index],
          quantity: numericValue === "" ? "" : Number(numericValue),
        };
      }

      return updatedRows;
    });
  };

  const handleVariantUnitChange = (index, value) => {
    const updated = [...variantRows];
    updated[index].unit = value;

    setVariantRows(updated);
  };

  /* ---------- UPDATE API ---------- */

  const updateVariants = () => {
    const payload = variantRows.map((variant) => ({
      variantId: variant.variantId || variant.id,
      quantity: parseInt(variant.quantity),
      productId: selectedProduct?.productId,
      unit: variant?.unit,
    }));

    console.log("payload is", payload);

    try {
      performRequest(
        "PATCH",
        `/pmg/fa-inventorys/update-fa-inventorys/${store?.UserId}`,
        { variants: payload }
      )
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Inventory Updated Successfully!");
            setRefresh(!refresh);
          }
        })

        .catch((err) => {
          CustomErrorResponse(err);
        });
    } catch (err) {
      console.log("error is", err);
    }
  };

  /* ---------- UPDATE API ---------- */

  // const addVariantsStock = () => {
  //   const payload = variantRows.map((variant) => ({
  //     variantId: variant.variantId || variant.id,
  //     quantity: parseInt(variant.quantity),
  //     productId: selectedProduct?.productId,
  //   }));

  //   try {
  //     performRequest(
  //       "PATCH",
  //       `/pmg/fa-inventorys/add-fa-stock/${store?.UserId}`,
  //       { variants: payload }
  //     )
  //       .then((res) => {
  //         if (res.status === 200) {
  //           let model = window.document.getElementById("closeModel");
  //           model.click();
  //           Toast("success", "Inventory Updated Successfully!");
  //           setRefresh(!refresh);
  //         }
  //       })

  //       .catch((err) => {
  //         CustomErrorResponse(err);
  //       });
  //   } catch (err) {
  //     console.log("error is", err);
  //   }
  // };

  const addVariantsStock = () => {
    const payload = instock.map((variant) => ({
      variantId: variant.variantId || variant.id,
      quantity: Number(variant.quantity) || 0,
      productId: selectedProduct?.productId,
    }));

    try {
      performRequest(
        "PATCH",
        `/pmg/fa-inventorys/add-fa-stock/${store?.UserId}`,
        { variants: payload }
      )
        .then((res) => {
          if (res.status === 200) {
            /* ✅ RESET STATE */
            setInStock((prev) =>
              prev.map((v) => ({
                ...v,
                quantity: "",
              }))
            );

            Toast("success", "Stock Added Successfully!");

            setRefresh(!refresh);

            /* CLOSE MODAL */
            const modal = document.getElementById("closeStockModel");
            if (modal) modal.click();
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    } catch (err) {
      console.log("error is", err);
    }
  };

  return (
    <>
      <div className="table-responsive">
        <table className="table table-vcenter">
          <thead>
            <tr>
              <th>Sr.</th>
              <th className="">Image</th>
              <th className="">Product Name</th>
              <th>Price</th>
              <th>Date</th>
              {store.Role !== "superAdmin" ? (
                <th>Add Stock</th>
              ) : (
                <th className="ps-7">In Stock</th>
              )}
              {store.Role !== "superAdmin" && <th>Update Stock</th>}
              <th className="text-start">View</th>
            </tr>
          </thead>

          <tbody>
            {groupedProducts?.map((item, index) => {
              const Index = (currentPage - 1) * itemsPerPage + index + 1;

              return (
                <tr key={item.productId}>
                  <td>{Index}</td>

                  <td className="">
                    <img
                      src={item?.pmg_product?.image}
                      alt="product"
                      width="30"
                    />
                  </td>

                  <td className="">{item?.pmg_product?.title || "N/A"}</td>

                  <td>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor: "#329537",
                          border: "0.5px solid #084121",
                          borderRadius: "6px",
                          color: "#fff",
                          fontSize: "16px",
                          fontWeight: "700",
                          lineHeight: "22px",
                          padding: "3px 9px",
                          textAlign: "center",
                          boxShadow: "1.5px 1.5px 0px #084121",
                          margin: 0,
                          marginTop: 2,
                        }}
                      >
                        ₹{item?.pmg_product_variant?.price || 0}
                      </span>
                    </div>
                  </td>

                  <td>{extractDate(item?.createdAt) || "N/A"}</td>

                  {store.Role !== "superAdmin" ? (
                    <td>
                      <div className="btn-list justify-content-center">
                        <span
                          data-bs-toggle="modal"
                          data-bs-target="#modal-add-item"
                        >
                          <button
                            className="btn btn-sm px-3 btn-primary"
                            onClick={() => openAddStockModal(item)}
                          >
                            <BsJournalArrowUp className="me-2 fs-4" />
                            Add Stock
                          </button>
                        </span>
                      </div>
                    </td>
                  ) : (
                    <td>
                      <div className="btn-list justify-content-center">
                        <span
                          data-bs-toggle="modal"
                          data-bs-target="#modal-in-stock"
                        >
                          <button
                            className="btn btn-sm px-3 btn-primary"
                            onClick={() => openInstockUpdateModal(item)}
                          >
                            <BsJournalArrowUp className="me-2 fs-4" />
                            In Stock
                          </button>
                        </span>
                      </div>
                    </td>
                  )}

                  {store.Role !== "superAdmin" && (
                    <td>
                      <div className="btn-list justify-content-center">
                        <span
                          data-bs-toggle="modal"
                          data-bs-target="#modal-update-item"
                        >
                          <button
                            className="btn btn-sm px-3 btn-primary"
                            onClick={() => openUpdateModal(item)}
                          >
                            <BsJournalArrowUp className="me-2 fs-4" />
                            Update Stock
                          </button>
                        </span>
                      </div>
                    </td>
                  )}

                  <td>
                    <CustomViewButton onClick={() => goToView(item?.id)} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* ----------Update MODAL ---------- */}

      <div
        className="modal modal-blur fade"
        id="modal-update-item"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            {/* HEADER */}
            <div className="modal-header">
              <h5 className="modal-title">
                Update Stock{" "}
                <span style={{ color: "green" }}>
                  {selectedProduct?.pmg_product?.title || ""}
                </span>
              </h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeModel"
              ></button>
            </div>

            {/* BODY */}
            <div className="modal-body">
              <div>
                {variantRows.map((v, index) => (
                  <div className="row mb-3" key={v.id}>
                    <div className="col-md-4">
                      <label className="form-label required">
                        Select Product
                      </label>

                      <input
                        className="form-control"
                        value={v?.pmg_product_variant?.title || "Variant"}
                        disabled
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label required">Quantity</label>
                      <input
                        type="number"
                        className="form-control"
                        value={v.quantity}
                        onChange={(e) =>
                          handleVariantQtyChange(index, e.target.value)
                        }
                      />
                    </div>

                    {/* Unit */}
                    <div className="col-md-4">
                      <label className="form-label required">Select Unit</label>
                      <select
                        className="form-control"
                        value={v.unit || ""}
                        onChange={(e) =>
                          handleVariantUnitChange(index, e.target.value)
                        }
                      >
                        <option value="">Select Unit</option>
                        <option value="nos">Nos</option>
                        <option value="kg">Kg</option>
                      </select>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={updateVariants}
              >
                Update Stock
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ----------Add Stock MODAL ---------- */}
      <div
        className="modal modal-blur fade"
        id="modal-add-item"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            {/* HEADER */}
            <div className="modal-header">
              <h5 className="modal-title">
                Add Stock{" "}
                <span style={{ color: "green" }}>
                  {selectedProduct?.pmg_product?.title || ""}
                </span>
              </h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeStockModel"
              ></button>
            </div>

            {/* BODY */}
            <div className="modal-body">
              {instock?.map((v, index) => (
                <div className="row mb-3" key={v.id}>
                  <div className="col-md-6">
                    <label className="form-label required">Variant Name</label>
                    <input
                      className="form-control"
                      value={v?.pmg_product_variant?.title || "Variant"}
                      disabled
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label required">
                      Add Stock Value
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={v.quantity}
                      onChange={(e) =>
                        handleVariantQtyChange(index, e.target.value)
                      }
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={addVariantsStock}
              >
                Add Stock
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ---------- IN STOCK MODAL ---------- */}
      <div
        className="modal modal-blur fade"
        id="modal-in-stock"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            {/* HEADER */}
            <div className="modal-header">
              <h5 className="modal-title">Stock Details</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            {/* BODY */}
            <div className="modal-body">
              {/* PRODUCT INFO */}
              <div className="mb-4">
                <h4 style={{ color: "#0d6efd" }}>
                  {console.log("selected produccts", selectedProduct)}
                  {selectedProduct?.pmg_product?.title}
                </h4>

                <p>{selectedProduct?.pmg_product?.body_html}</p>
              </div>

              {/* VARIANT TABLE */}
              <div className="table-responsive">
                <table className="table table-bordered align-middle">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "40%" }}>Sr</th>
                      <th style={{ width: "40%" }}>Variant Name</th>
                      <th style={{ width: "30%" }}>Price</th>
                      <th style={{ width: "30%" }}>Quantity</th>
                    </tr>
                  </thead>

                  <tbody>
                    {variantRows?.map((v, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{v?.pmg_product_variant?.title || "Variant"}</td>

                        <td>₹{v?.pmg_product_variant?.price || 0}</td>

                        <td>{v?.quantity || 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FarmerInventoryTable;
